
import Loading from "@/components/Loading.vue";
import { mapActions, mapMutations } from "vuex";
import { yearBrackets } from "./utils";
import { defineComponent } from "vue";
import { CarByVin, CarType, mapCarByVinToCar } from "@/cars/types";

interface SelectByVinData {
  vin: String;
  types: Array<CarType>;
  selectedType: null | Number;
  checkingVin: Boolean;
  loadingTypes: Boolean;
  carsByVin: Array<CarByVin>;
}

export default defineComponent({
  data(): SelectByVinData {
    return {
      vin: "",
      types: [],
      selectedType: null,
      checkingVin: false,
      loadingTypes: false,
      carsByVin: [],
    };
  },
  methods: {
    ...mapMutations(["addCar"]),
    ...mapActions("cars", ["getByVin"]),
    toggleVinSelect() {
      this.$emit("toggleVinSelect");
    },
    correctVin() {
      this.types = [];
    },
    selectVin() {
      if (!this.vin) return;
      if (this.selectedType) {
        const selectedCar = this.carsByVin.find(
          (car: any) => car.type.typeId === this.selectedType
        )!;
        const car = mapCarByVinToCar(selectedCar, this.vin);
        this.selectedType = null;
        this.types = [];
        this.vin = "";
        this.$emit("carAdded", car);
      } else {
        this.checkingVin = true;
        this.getByVin(this.vin).then((response) => {
          this.carsByVin = response.data.cars;
          this.types = this.carsByVin.map((car) => car.type);
          if (this.types.length === 1) {
            this.selectedType = this.types[0].typeId;
            this.selectVin();
          }
          this.checkingVin = false;
        });
      }
    },
    typeOptionName(car: CarByVin) {
      return `${car.manufacturer.MakeName} ${car.serie.rangeName} ${car.type.typeName} [${car.type.kw} kW] (${car.type.fuel})${yearBrackets(
        car.type.yearFrom,
        car.type.yearTo
      )}`;
    },
  },
  components: {
    Loading,
  },
});
